export default "__VITE_ASSET__D4Jni_K6__"